<div class="form-content">
    <div class="form-content__title">
        <span>
            {{'CUSTOMER_DETAILS' | translate}}
        </span>
        <div class="form-content__list_numbers">
            <div *ngFor="let stepForm of stepValidForms">
                <div class="form-content__number" [ngClass]="{'active': step === stepForm.step, 'is_valid': stepForm.formValid, 'is_invalid': !stepForm.formValid && step > stepForm.step}">
                    <span *ngIf="!stepForm.formValid && step <= stepForm.step">{{stepForm.step}}</span>
                    <span *ngIf="!stepForm.formValid && step > stepForm.step"><i class="material-icons notranslate">close</i></span>
                    <span *ngIf="stepForm.formValid"><i class="material-icons notranslate">check</i></span>
                </div>
            </div>
        </div>
    </div>
    <form [formGroup]="formGroup">
        <div formArrayName="items" *ngFor="let item of formGroup.get('items')['controls']; let i = index;">
            <div *ngIf="step === i + 1" class="form-content__item">
                <h3> Nº {{unit[i].number}} {{unit[i].person.name.toUpperCase() | translate}} </h3>
                <div [formGroupName]="i">
                    <div class="css-form-row">
                        <span class="fake-input"
                            [ngClass]="{'ng-valid': item.get('name').touched && item.get('name').valid, 'ng-invalid': item.get('name').touched && !item.get('name').valid}">
                            <input
                                formControlName="name"
                                placeholder="{{'NAME' | translate}}"
                                type="text"/>
                        </span>
                        <span class="fake-input"
                            [ngClass]="{'ng-valid': item.get('surname').touched && item.get('surname').valid, 'ng-invalid': item.get('surname').touched && !item.get('surname').valid}">
                            <input
                                formControlName="surname"
                                placeholder="{{'LASTNAME' | translate}}"
                                type="text"/>
                        </span>
                    </div>
                
                    <div class="css-form-row">
                        <span class="fake-input"
                            [ngClass]="{'ng-valid': item.get('idCard').touched && item.get('idCard').valid, 'ng-invalid': item.get('idCard').touched && !item.get('idCard').valid}">
                            <input
                                class="text-required"
                                formControlName="idCard"
                                placeholder="{{'ID_PASSPORT' | translate}}"
                                type="text" />
                        </span>
                        <div *ngIf="unit[i].person.maxAge < 18" class="require-field">
                            <span>*{{'CHILD_NOT_PASSPORT' | translate}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>